import aiGatewayAPIInstance from "./aiGatewayApiInstance";

const DEFAULT_CHAPTERIZE_LANGUAGES = {
  key: "chapterize_languages",
  value: [
    { French: "arabe", alpha2: "ar", English: "Arabic", "alpha3-b": "ara", "alpha3-t": null },
    { French: "bulgare", alpha2: "bg", English: "Bulgarian", "alpha3-b": "bul", "alpha3-t": null },
    { French: "catalan; valencien", alpha2: "ca", English: "Catalan; Valencian", "alpha3-b": "cat", "alpha3-t": null },
    { French: "chinois", alpha2: "zh", English: "Chinese", "alpha3-b": "chi", "alpha3-t": "zho" },
    { French: "tchèque", alpha2: "cs", English: "Czech", "alpha3-b": "cze", "alpha3-t": "ces" },
    { French: "danois", alpha2: "da", English: "Danish", "alpha3-b": "dan", "alpha3-t": null },
    { French: "néerlandais; flamand", alpha2: "nl", English: "Dutch; Flemish", "alpha3-b": "dut", "alpha3-t": "nld" },
    { French: "anglais", alpha2: "en", English: "English", "alpha3-b": "eng", "alpha3-t": null },
    { French: "estonien", alpha2: "et", English: "Estonian", "alpha3-b": "est", "alpha3-t": null },
    { French: "finnois", alpha2: "fi", English: "Finnish", "alpha3-b": "fin", "alpha3-t": null },
    { French: "français", alpha2: "fr", English: "French", "alpha3-b": "fre", "alpha3-t": "fra" },
    { French: "allemand", alpha2: "de", English: "German", "alpha3-b": "ger", "alpha3-t": "deu" },
    {
      French: "grec moderne (après 1453)",
      alpha2: "el",
      English: "Greek, Modern (1453-)",
      "alpha3-b": "gre",
      "alpha3-t": "ell",
    },
    { French: "hindi", alpha2: "hi", English: "Hindi", "alpha3-b": "hin", "alpha3-t": null },
    { French: "hongrois", alpha2: "hu", English: "Hungarian", "alpha3-b": "hun", "alpha3-t": null },
    { French: "indonésien", alpha2: "id", English: "Indonesian", "alpha3-b": "ind", "alpha3-t": null },
    { French: "italien", alpha2: "it", English: "Italian", "alpha3-b": "ita", "alpha3-t": null },
    { French: "japonais", alpha2: "ja", English: "Japanese", "alpha3-b": "jpn", "alpha3-t": null },
    { French: "coréen", alpha2: "ko", English: "Korean", "alpha3-b": "kor", "alpha3-t": null },
    { French: "letton", alpha2: "lv", English: "Latvian", "alpha3-b": "lav", "alpha3-t": null },
    { French: "lituanien", alpha2: "lt", English: "Lithuanian", "alpha3-b": "lit", "alpha3-t": null },
    { French: "marathe", alpha2: "mr", English: "Marathi", "alpha3-b": "mar", "alpha3-t": null },
    { French: "malais", alpha2: "ms", English: "Malay", "alpha3-b": "may", "alpha3-t": "msa" },
    { French: "norvégien", alpha2: "no", English: "Norwegian", "alpha3-b": "nor", "alpha3-t": null },
    { French: "polonais", alpha2: "pl", English: "Polish", "alpha3-b": "pol", "alpha3-t": null },
    { French: "portugais", alpha2: "pt", English: "Portuguese", "alpha3-b": "por", "alpha3-t": null },
    {
      French: "roumain; moldave",
      alpha2: "ro",
      English: "Romanian; Moldavian; Moldovan",
      "alpha3-b": "rum",
      "alpha3-t": "ron",
    },
    { French: "russe", alpha2: "ru", English: "Russian", "alpha3-b": "rus", "alpha3-t": null },
    { French: "slovaque", alpha2: "sk", English: "Slovak", "alpha3-b": "slo", "alpha3-t": "slk" },
    { French: "espagnol; castillan", alpha2: "es", English: "Spanish; Castilian", "alpha3-b": "spa", "alpha3-t": null },
    { French: "suédois", alpha2: "sv", English: "Swedish", "alpha3-b": "swe", "alpha3-t": null },
    { French: "thaï", alpha2: "th", English: "Thai", "alpha3-b": "tha", "alpha3-t": null },
    { French: "turc", alpha2: "tr", English: "Turkish", "alpha3-b": "tur", "alpha3-t": null },
    { French: "ukrainien", alpha2: "uk", English: "Ukrainian", "alpha3-b": "ukr", "alpha3-t": null },
    { French: "vietnamien", alpha2: "vi", English: "Vietnamese", "alpha3-b": "vie", "alpha3-t": null },
  ],
};

export const chapterizeLanguagesAPIs = {
  getChapterizeLanguages: () =>
    aiGatewayAPIInstance.get("/settings/chapterize_languages").catch(() => ({
      data: DEFAULT_CHAPTERIZE_LANGUAGES,
    })),
};
